import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import NewNavbar from 'Components/UI/Navigation/NewNavbar';
import useMobileLayout from 'Hooks/useMobileLayout';
import Navbar from './Navbar';

const styles = () => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});

const OnboardingNavbar = ({
  className,
  classes,
  clientResource,
  ...rest
}) => {
  const isMobile = useMobileLayout();

  if (isMobile) return null;
  return (
    <NewNavbar
      className={classNames(classes.root, className)}
      MenuButtonProps={{ test: 'onboarding-desktop-nav-menu-button' }}
      {...rest}
    >
      <Navbar clientResource={clientResource} />
    </NewNavbar>
  );
};

OnboardingNavbar.defaultProps = {
  className: '',
};

OnboardingNavbar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingNavbar);
